<template>
  <div class="stop-wrapper">
    <div class="stop-content">
      <img class="lock-img" src="../../assets/img/lock.png" alt="">
      <div v-if="custom">
        <p class="text1">{{ custom }}</p>
      </div>
      <div v-else>
        <p class="text1">该页面信息仅对 <span class="highlight">TGO 鲲鹏会学员</span> 展示</p>
        <p v-if="!isLogin" class="text2">请登录后查看</p>
        <a v-if="!isLogin" class="login-button" :href="accountLink">立即登录</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['custom'],
  computed: {
    ...mapState([
      'isLogin'
    ]),
    href () {
      return window.location.href
    },
    accountLink () {
      return `https://account.geekbang.org/infoq/login?redirect=${encodeURIComponent(this.href)}`
    }
  }
}
</script>

<style lang="sass" scoped>
@import '../../style/bulma/app.sass'
.stop-wrapper
  position: relative
  height: 824px
  +mobile
    height: 500px

  .stop-content
    display: flex
    flex-direction: column
    align-items: center
    width: 300px
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    margin: auto
    +mobile
      width: 84vw

    .lock-img
      width: 38%
      margin-bottom: 40px
      +mobile
        margin-bottom: 30px

    .text1, .text2
      color: #202124
      font-size: 16px
      text-align: center
      .highlight
        // color: $primary3
        margin: 0 3px

    .login-button
      display: block
      width: 45%
      color: #fff
      font-size: 16px
      text-align: center
      padding: 6px 0
      margin-top: 30px
      margin-left: auto
      margin-right: auto
      border-radius: 5px
      box-sizing: border-box
      background: $primary4
      cursor: pointer
      +mobile
        margin-top: 20px
</style>
